import { useEffect, useState } from "react";
import { FlexGrow } from "../../components/FlexBox";
import theme from "../../styles/theme";
import { CompetencyTable } from "./competencyTable";
import axios from "axios";
import MinimalSelect from "../../components/MinimalSelect";
import LoadingSpinner from "../../components/LoadingSpinner";
import { Icon } from "@mui/material";
import SearchBox from "./SearchBox";

interface UniversityOption {
  label: string;
  value: string;
  programs: any[];
}

interface Props {
  isSuperUser: boolean;
}
export const CompetencyAllVersion = (props: Props) => {
  const { isSuperUser } = props;
  const [idCode, setIdCode] = useState("");
  const [competencyList, setCompetencyList] = useState<any>(null);
  const [allCompetencies, setAllCompetencies] = useState<any>([]);

  const [selectedUni, setSelectedUni] = useState<any>(
    localStorage.getItem("university") || ""
  );
  const [universityOption, setUniversityOption] = useState<UniversityOption[]>(
    []
  );
  const [loading, setLoading] = useState(false);
  const [idCodeOptions, setIdCodeOptions] = useState([]);
  const [programOptions, setProgramOptions] = useState<any[]>([]);
  const [selectedProgram, setSelectedProgram] = useState<any>(
    localStorage.getItem("selectedProgram") ||
    ""
  );
  const [keyword, setKeyword] = useState<string>("");
  const [selectedTab, setSelectedTab] = useState<"competency" | "code">("code");

  // console.log('comeptency list', competencyList);

  const onIDcodeChange = (
    keyword: any,
    university: any,
    program: string,
    activeTab: "competency" | "code" = selectedTab
  ) => {
    setLoading(true);
    setSelectedUni(university);

    setIdCode(keyword);
    localStorage.setItem("searchKeyword", keyword);
    var url = `/competency/identity`;
    const codeParam =
      activeTab === "competency" ? "competency_code" : "identity_code";

    if (searchKeyword && university) {
      url = `/competency/identity?${codeParam}=${keyword}&university_code=${university}&program_name=${program}`;
    } else if (keyword && university) {
      url = `/competency/identity?${codeParam}=${keyword}&university_code=${university}&program_name=${program}`;
    } else if (!keyword && university) {
      url = `/competency/identity?university_code=${university}&program_name=${program}`;
    } else if (keyword && !university) {
      url = `/competency/identity?${codeParam}=${keyword}`;
    }
    axios
      .get(url)
      .then((res) => {
        if (!res.data.competencies) {
          setCompetencyList([]);
        } else {
          // res.data.competencies.sort((a: any, b: any) =>
          //   a.identity_code.localeCompare(b.identity_code)
          // );
          setCompetencyList(res.data.competencies);
        }
      })
      .catch((err: any) => {
        if (err?.response?.data?.message === "missing or malformed jwt") {
          window.location.pathname = "/signin";
        }
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const [resetSearch, setResetSearch] = useState(false);

  const handleTabChange = (nextTab: "competency" | "code") => {
    if (nextTab === selectedTab) return;

    setSelectedTab(nextTab);
    setKeyword("");
    setIdCode("");
    setResetSearch(!resetSearch);

    localStorage.removeItem("searchKeyword");

    onIDcodeChange(
      "",
      selectedUni,
      selectedProgram,
      nextTab
    );
  };

  const fetchUniversities = () => {
    axios
      .get("/university")
      .then((res) => {
        const array: any = [];
        const raw = res.data.universities.forEach((v: any) =>
          array.push({
            label: v.short_name,
            value: v.short_name,
            programs: v.program,
          })
        );
        setUniversityOption(array);
        setProgramOptions(
          (
            array.find(
              (uni: any) => uni.value === localStorage.getItem("university")
            )?.programs || []
          )?.map((p: any) => ({
            label: p.short_name,
            value: p.short_name,
          }))
        );
        setSelectedProgram(
          localStorage.getItem("selectedProgram") ||
          array.find(
            (uni: any) => uni.value === localStorage.getItem("university")
          )?.programs?.find((p: any) => p?.short_name === "B.ENG. AiCE")?.short_name ||
          array.find(
            (uni: any) => uni.value === localStorage.getItem("university")
          )?.programs[0]?.short_name ||
          ""
        );
        // setSelectedProgram(localStorage.getItem("selectedProgram"));
        searchKeyword
          ? onIDcodeChange(
            searchKeyword,
            localStorage.getItem("university"),
            localStorage.getItem("selectedProgram") || selectedProgram ||
            array.find(
              (uni: any) => uni.value === localStorage.getItem("university")
            )?.programs?.find((p: any) => p?.short_name === "B.ENG. AiCE")?.short_name ||
            array.find(
              (uni: any) => uni.value === localStorage.getItem("university")
            )?.programs?.[0]?.short_name
          )
          : getCompetencies(
            localStorage.getItem("university"),
            localStorage.getItem("selectedProgram")
          );
      })
      .catch(function (error) { });
  };

  const searchKeyword = localStorage.getItem("searchKeyword");

  const getCompetencies = (university: any, program: any) => {
    setLoading(true);
    var url = !university
      ? "/competency/identity"
      : `/competency/identity?university_code=${university}&program_name=${selectedProgram
      }`;
    axios
      .get(url)
      .then((res) => {
        // res.data.competencies.sort((a: any, b: any) =>
        //   a.identity_code.localeCompare(b.identity_code)
        // );
        setCompetencyList(res.data.competencies);
        setLoading(false);

        const uniqueCodes = res.data.competencies.reduce(
          (acc: any, current: any) => {
            if (
              !acc.some(
                (item: any) => item.identity_code === current.identity_code
              )
            ) {
              acc.push(current);
            }
            return acc;
          },
          []
        );
        const modifiedArray = uniqueCodes.map((item: any) => ({
          label: item.identity_code,
          value: item.identity_code,
        }));
        setIdCodeOptions(modifiedArray);
      })
      .catch((err: any) => {
        setCompetencyList([]);
        setLoading(false);
        if (err?.response?.data?.message === "missing or malformed jwt") {
          window.location.pathname = "/signin";
        }
      });
  };

  useEffect(() => {
    universityOption?.length === 0 && fetchUniversities();

    // !selectedUni && setSelectedUni(searchUniversity);
    // searchKeyword && selectedUni?
    //   onIDcodeChange(
    //     searchKeyword,
    //     selectedUni,
    //     selectedProgram
    //   ): onIDcodeChange(
    //     searchKeyword,
    //     "",
    //     ""
    //   )
  }, []);

  return (
    <div style={{}}>
      <div
        style={{
          display: "inline-flex",
          gap: 6,
          padding: 4,
          border: "1px solid #d7d7d7",
          borderRadius: 8,
          marginBottom: 8,
          background: "#f7f8ff",
          boxShadow: "inset 0 0 0 1px rgba(255,255,255,0.7), 0 1px 2px rgba(0,0,0,0.06)",
        }}
      >
        <button
          type="button"
          disabled={loading}
          onClick={() => handleTabChange("code")}
          style={{
            minWidth: 200,
            padding: "8px 12px",
            borderRadius: 6,
            border: selectedTab === "code" ? "1px solid rgba(38, 51, 212, 0.35)" : "1px solid transparent",
            background:
              selectedTab === "code"
                ? "linear-gradient(180deg, rgb(111, 123, 255), rgb(38, 51, 212))"
                : "transparent",
            color: selectedTab === "code" ? "white" : "rgb(110, 110, 110)",
            fontSize: 14,
            fontWeight: 600,
            letterSpacing: 0.2,
            cursor: loading ? "not-allowed" : "pointer",
            userSelect: "none",
            outline: "none",
            opacity: loading ? 0.7 : 1,
            boxShadow: selectedTab === "code" ? "0 6px 14px rgba(38, 51, 212, 0.18)" : "none",
            transition:
              "background 180ms ease, color 180ms ease, border-color 180ms ease, box-shadow 180ms ease, transform 120ms ease",
          }}
          onMouseDown={(e) => {
            (e.currentTarget as HTMLButtonElement).style.transform = "translateY(1px)";
          }}
          onMouseUp={(e) => {
            (e.currentTarget as HTMLButtonElement).style.transform = "translateY(0px)";
          }}
          onMouseLeave={(e) => {
            (e.currentTarget as HTMLButtonElement).style.transform = "translateY(0px)";
          }}
          onFocus={(e) => {
            (e.currentTarget as HTMLButtonElement).style.boxShadow =
              selectedTab === "code"
                ? "0 0 0 3px rgba(111, 123, 255, 0.35), 0 6px 14px rgba(38, 51, 212, 0.18)"
                : "0 0 0 3px rgba(111, 123, 255, 0.25)";
          }}
          onBlur={(e) => {
            (e.currentTarget as HTMLButtonElement).style.boxShadow =
              selectedTab === "code" ? "0 6px 14px rgba(38, 51, 212, 0.18)" : "none";
          }}
        >
          By Identity Code
        </button>

        <button
          type="button"
          disabled={loading}
          onClick={() => handleTabChange("competency")}
          style={{
            minWidth: 200,
            padding: "8px 12px",
            borderRadius: 6,
            border:
              selectedTab === "competency" ? "1px solid rgba(38, 51, 212, 0.35)" : "1px solid transparent",
            background:
              selectedTab === "competency"
                ? "linear-gradient(180deg, rgb(111, 123, 255), rgb(38, 51, 212))"
                : "transparent",
            color: selectedTab === "competency" ? "white" : "rgb(110, 110, 110)",
            fontSize: 14,
            fontWeight: 600,
            letterSpacing: 0.2,
            cursor: loading ? "not-allowed" : "pointer",
            userSelect: "none",
            outline: "none",
            opacity: loading ? 0.7 : 1,
            boxShadow: selectedTab === "competency" ? "0 6px 14px rgba(38, 51, 212, 0.18)" : "none",
            transition:
              "background 180ms ease, color 180ms ease, border-color 180ms ease, box-shadow 180ms ease, transform 120ms ease",
          }}
          onMouseDown={(e) => {
            (e.currentTarget as HTMLButtonElement).style.transform = "translateY(1px)";
          }}
          onMouseUp={(e) => {
            (e.currentTarget as HTMLButtonElement).style.transform = "translateY(0px)";
          }}
          onMouseLeave={(e) => {
            (e.currentTarget as HTMLButtonElement).style.transform = "translateY(0px)";
          }}
          onFocus={(e) => {
            (e.currentTarget as HTMLButtonElement).style.boxShadow =
              selectedTab === "competency"
                ? "0 0 0 3px rgba(111, 123, 255, 0.35), 0 6px 14px rgba(38, 51, 212, 0.18)"
                : "0 0 0 3px rgba(111, 123, 255, 0.25)";
          }}
          onBlur={(e) => {
            (e.currentTarget as HTMLButtonElement).style.boxShadow =
              selectedTab === "competency" ? "0 6px 14px rgba(38, 51, 212, 0.18)" : "none";
          }}
        >
          By Competency Code
        </button>
      </div>
      <FlexGrow
        style={{
          background: "white",
          overflow: "auto",
          // maxHeight: "calc(100vh - 90px)",
          height: "calc(90vh - 10px)",
          color: "black",
          // padding: 10,
        }}
      >
        <span style={{ color: "blue" }}>
          {/* Enter the identity code to view related competencies for all Versions :{" "} */}
        </span>
        <div
          style={{
            display: "flex",
            padding: "16px",
            justifyContent: "space-between",
          }}
        >
          <div style={{ display: "flex", minWidth: 400 }}>
            {/* <MinimalSelect
            placeholder={
              <div style={{ display: "flex", alignItems: "center" }}>
                <Icon fontSize="small" style={{ paddingRight: 5, color:"gray"}}>
                  search_icon
                </Icon>
                Identity code ...
              </div>
            }
            onChange={(e: any) => onIDcodeChange(e.value, selectedUni)}
            // value={pillars.filter((el) => el.value === field.value)}
            menuPortalTarget={document.body}
            styles={{
              menuPortal: (base) => ({
                ...base,
                zIndex: 9999,
                color: theme.color.lightBlueGray800,
              }),
            }}
            options={idCodeOptions}
          /> */}
            <SearchBox
              keyword={keyword}
              width={300}
              resetSearch={resetSearch}
              defaultKeyword={
                localStorage.getItem("searchKeyword") as string
              }
              label={selectedTab === "competency" ? "Search by competency code" : "Search by identity code"}
              onSearch={(keyword: string) => {
                onIDcodeChange(
                  selectedTab === "competency" ? keyword.toUpperCase() : keyword,
                  selectedUni,
                  selectedProgram
                );
              }}
            />
            {/* <Button
            style={{
              color: "white",
              border: "none",
              // minHeight: "32px",
              fontSize: "14px",
              background: theme.color.blueButton,
            }}
            onClick={() => onSearch(isSuperUser ? selectedUni : university)}
          >
            Search
          </Button> */}
          </div>
          {isSuperUser && (
            <div style={{ display: "flex", gap: 10 }}>
              <div>
                University :
                <MinimalSelect
                  isClearable={false}
                  value={
                    universityOption?.find(
                      (uni: any) => uni.value === selectedUni
                    ) || { label: "All", value: "" }
                  }
                  onChange={(item: any) => {
                    const localSelectedProgram =
                      localStorage.getItem("selectedProgram");
                    const mappedPrograms = (
                      universityOption.find(
                        (uni: any) => uni.value === item.value
                      )?.programs || []
                    ).map((p: any) => ({
                      label: p.short_name,
                      value: p.short_name,
                    }));
                    const defaultProgram =
                      (localSelectedProgram !== "Aii" &&
                        mappedPrograms?.find((p) => p.value === "B.ENG. AiCE")
                          ?.value) ||
                      mappedPrograms?.[0]?.value;
                    const nextProgram =
                      item.value === "CMKL" &&
                      (localSelectedProgram === "Aii" ||
                        localSelectedProgram === "B.ENG. AiCE")
                        ? localSelectedProgram
                        : defaultProgram;

                    if (item.value === "") {
                      localStorage.removeItem("selectedProgram");
                      localStorage.removeItem("selectedProgId");

                      onIDcodeChange(idCode, "", "");
                    }

                    // getCompetencies(item.value, selectedProgram||programOptions[0]?.value);
                    onIDcodeChange(
                      idCode,
                      item.value,
                      nextProgram
                    );
                    setProgramOptions(
                      mappedPrograms
                    );

                    setSelectedProgram(nextProgram);
                  }}
                  name={"university"}
                  options={universityOption}
                  styles={{
                    container: (base) => ({
                      ...base,
                      minWidth: "200px",
                      marginLeft: "10px",
                    }),
                    menuPortal: (base) => ({
                      ...base,
                      zIndex: 9999,
                      color: theme.color.lightBlueGray800,
                    }),
                  }}
                />
              </div>
              {selectedUni && (
                <div>
                  Program :
                  <MinimalSelect
                    isClearable={false}
                    value={
                      programOptions?.find(
                        (p: any) => p.value === selectedProgram
                      ) || programOptions.find((p: any) => p.value === "B.ENG. AiCE") || programOptions[0]
                    }
                    onChange={(item: any) => {
                      setSelectedProgram(item.value);
                      onIDcodeChange(
                        idCode,
                        selectedUni,
                        item.value
                      );
                    }}
                    name={"university"}
                    options={programOptions}
                    styles={{
                      container: (base) => ({
                        ...base,
                        minWidth: "200px",
                        marginLeft: "10px",
                      }),
                      menuPortal: (base) => ({
                        ...base,
                        zIndex: 9999,
                        color: theme.color.lightBlueGray800,
                      }),
                    }}
                  />
                </div>
              )}
            </div>
          )}
        </div>
        {loading ? (
          <LoadingSpinner />
        ) : (
          <CompetencyTable
            loading={loading}
            competencyList={competencyList}
            variant={selectedTab}
          />
        )}
      </FlexGrow></div>
  );
};
